import script from "./view_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./view_modal.vue?vue&type=script&setup=true&lang=js"

import "./view_modal.vue?vue&type=style&index=0&id=8c2ad308&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2ad308"]])

export default __exports__